// Resolve translated Journey content without silently claiming generic NHS
// information is an individual NHS Trust's approved instruction.
export function translateJourneyValueWithSource(journeyId, suffix, fallback, t, sourceTranslationIds = {}) {
  if (!fallback) return fallback;

  const read = (id) => {
    const key = `journeys.${id}.${suffix}`;
    const translated = t(`hospitalJourney:${key}`, { defaultValue: '' });
    return typeof translated === 'string' && translated.trim()
      && translated !== key && translated !== `hospitalJourney:${key}`
      ? translated : null;
  };

  // A reviewed, explicitly authored generic translation can always be used.
  const direct = read(journeyId);
  if (direct) return direct;

  // Generic NHS safety notices have their own hospital-neutral first-pass
  // translations. Never inherit a named-Trust or draft-specific disclaimer.
  // Dedicated generic Journey translations (when provided) still take priority.
  if (suffix === 'disclaimer' && journeyId.startsWith('generic-')) {
    const safetyKey = journeyId === 'generic-day-surgery'
      ? 'daySurgeryDisclaimer' : 'generalDisclaimer';
    const key = `hospitalJourney:genericSafety.${safetyKey}`;
    const translation = t(key, { defaultValue: '' });
    if (typeof translation === 'string' && translation.trim() && translation !== key) {
      return translation;
    }
    return fallback;
  }

  const sourceId = sourceTranslationIds[journeyId];
  if (sourceId) {
    const source = read(sourceId);
    if (source) return source;
  }
  return fallback;
}
